/*
 * @Descripttion:
 * @version:
 * @Author: JiaLe
 * @Date: 2021-09-18 10:26:59
 * @LastEditors: wuyujiang 563306293@qq.com
 * @LastEditTime: 2026-04-14 13:55:55
 */
import Vue from "vue";

import VueRouter from "vue-router";
import "nprogress/nprogress.css";
// import { GetUrlParam } from "../utils/util";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/eidAlAdha",
  //   name: "EidAlAdha",
  //   component: () => import("@/view/activePage/eidAlAdha/index"),
  //   meta: {
  //     title: "eidAlAdha",
  //   },
  // },
  {
    path: "/rankingRule",
    name: "rankingRule",
    component: () => import("@/view/activePage/rankingRule"),
    meta: {
      title: "Ranking Rules",
    },
  },
  {
    path: "/count",
    name: "count",
    component: () => import("@/view/activePage/count"),
    meta: {
      title: "count",
    },
  },
  {
    path: "/guild",
    name: "guild",
    component: () => import("@/view/activePage/guild"),
    meta: {
      title: "guild",
    },
  },
  {
    path: "/guild2",
    name: "guild2",
    component: () => import("@/view/activePage/guild2"),
    meta: {
      title: "guild2",
    },
  },
  {
    //万圣节活动
    path: "/halloween",
    name: "halloween",
    component: () => import("@/view/activePage/halloween"),
    meta: {
      title: "halloween",
    },
  },
  {
    //万圣节活动规则
    path: "/halloween/rule",
    name: "halloween",
    component: () => import("@/view/activePage/halloween/rule"),
    meta: {
      title: "rule",
    },
  },
  {
    path: "/point_exchange",
    name: "points",
    component: () => import("@/view/integral/index"),
    meta: {
      // title: '上麦时长统计'
      title: "points",
    },
  },
  {
    path: "/point_exchange/detail",
    name: "pointsdetail",
    component: () => import("@/view/integral/detail"),
    meta: {
      title: "detail",
    },
  },
  {
    path: "/point_exchange/withdrawDetail",
    name: "withdrawDetail",
    component: () => import("@/view/integral/withdrawDetail"),
    meta: {
      title: "withdrawDetail",
    },
  },

  {
    path: "/point_operate", //应该是没用了 用的 //point_exchange
    name: "points",
    component: () => import("@/view/integral2/index"),
    meta: {
      // title: '上麦时长统计'
      title: "points",
    },
  },
  {
    path: "/point_operate/detail",
    name: "pointsdetail",
    component: () => import("@/view/integral2/detail"),
    meta: {
      title: "detail",
    },
  },
  {
    path: "/game_rank",
    name: "GameRankList",
    component: () => import("@/view/game_rank/index"),
    meta: {
      // title: '上麦时长统计'
      title: "rankList",
    },
  },
  {
    path: "/game_rankRule",
    name: "GameRankListRule",
    component: () => import("@/view/game_rank/rule"),
    meta: {
      // title: '上麦时长统计'
      title: "game_rankRule",
    },
  },
  {
    path: "/game_rankRule2",
    name: "GameRankListRule2",
    component: () => import("@/view/game_rank/rule2"),
    meta: {
      // title: '上麦时长统计'
      title: "game_rankRule2",
    },
  },
  {
    path: "/banner_rank",
    name: "RankList",
    component: () => import("@/view/list_rank/index"),
    meta: {
      // title: '上麦时长统计'
      title: "rankList",
    },
  },
  {
    path: "/contribution_rank",
    name: "ContributionList",
    component: () => import("@/view/list_contribution/index"),
    meta: {
      title: "contributionList",
    },
  },
  {
    path: "/rank_room",
    name: "RoomList",
    component: () => import("@/view/list_room/index"),
    meta: {
      title: "contributionList",
    },
  },
  {
    path: "/user_level",
    name: "LevelDescription",
    component: () => import("@/view/description_level/index"),
    meta: {
      // title: '上麦时长统计'
      title: "levelDescription",
    },
  },
  {
    path: "/coin_detail",
    name: "goldetail",
    component: () => import("@/view/gold/detail"),
    meta: {
      title: "detail",
    },
  },
  {
    path: "/conduct",
    name: "Conduct",
    component: () => import("@/view/activePage/attention/index"),
    meta: {
      // title: '上麦时长统计'
      title: "attention",
    },
  },
  {
    path: "/vpnNotice",
    name: "VpnNotice",
    component: () => import("@/view/activePage/vpnNotice/index"),
    meta: {
      title: "vpnNotice",
    },
  },
  {
    path: "/firstLeader",
    name: "FirstLeader",
    component: () => import("@/view/activePage/firstLeader/index"),
    meta: {
      // title: '上麦时长统计'
      title: "firstLeader",
    },
  },
  {
    path: "/vipIntroduction",
    name: "VipIntroduction",
    component: () => import("@/view/activePage/vipIntroduction/index"),
    meta: {
      // title: '上麦时长统计'
      title: "vipIntroduction",
    },
  },
  {
    path: "/bewareOfScams",
    name: "BewareOfScams",
    component: () => import("@/view/activePage/bewareOfScams/index"),
    meta: {
      // title: '上麦时长统计'
      title: "bewareOfScams",
    },
  },
  {
    path: "/storeAc",
    name: "StoreAc",
    component: () => import("@/view/activePage/storeAc/index"),
    meta: {
      title: "storeAc",
    },
  },
  {
    path: "/redPacket",
    name: "RedPacket",
    component: () => import("@/view/activePage/red_packet/index"),
    meta: {
      title: "attention",
    },
  },
  {
    path: "/ChristmasEvent",
    name: "Christmas",
    component: () => import("@/view/activePage/christmas/index"),
    meta: {
      title: "christmas",
    },
  },
  {
    path: "/christmasEvent2Banner",
    name: "ChristmasEvent2Banner",
    component: () => import("@/view/activePage/christmas2/banner.vue"),
    meta: {
      title: "ChristmasEvent2Banner",
    },
  },
  {
    path: "/ChristmasEvent2",
    name: "Christmas2",
    component: () => import("@/view/activePage/christmas2/index"),
    meta: {
      title: "christmas",
    },
  },
  {
    path: "/valentinesDay",
    name: "ValentinesDay",
    component: () => import("@/view/activePage/valentinesDay/index"),
    meta: {
      title: "valentinesDay",
    },
  },
  {
    path: "/ramadanPre",
    name: "Ramadanpre",
    component: () => import("@/view/activePage/ramadanpre/index"),
    meta: {
      title: "ramadanpre",
    },
  },
  {
    path: "/ramadan",
    name: "Ramadan",
    component: () => import("@/view/activePage/ramadan/index"),
    meta: {
      title: "ramadan",
    },
  },
  {
    path: "/ramadan2",
    name: "Ramadan2",
    component: () => import("@/view/activePage/ramadan2/index"),
    meta: {
      title: "ramadan2",
    },
  },
  {
    path: "/agentActivity",
    name: "AgentActivity",
    component: () => import("@/view/activePage/agentActivity/index"),
    meta: {
      title: "agentActivity",
    },
  },
  {
    path: "/eidAlAdha",
    name: "EidAlAdha",
    component: () => import("@/view/activePage/eidAlAdha/index"),
    meta: {
      title: "eidAlAdha",
    },
  },
  {
    path: "/agentRank",
    name: "AgentRank",
    component: () => import("@/view/activePage/agentRank/index"),
    meta: {
      title: "attention",
    },
  },
  {
    path: "/agentRank2",
    name: "AgentRank2",
    component: () => import("@/view/activePage/agentRank2/index"),
    meta: {
      // title: '上麦时长统计'
      title: "attention",
    },
  },
  {
    path: "/agentRankResult",
    name: "AgentRankResult",
    component: () => import("@/view/activePage/agentRankResult/index"),
    meta: {
      // title: '上麦时长统计'
      title: "attention",
    },
  },
  {
    path: "/agentEvent",
    name: "AgentEvent",
    component: () => import("@/view/activePage/agentEvent/index"),
    meta: {
      title: "agentEvent",
    },
  },
  {
    path: "/starAgency",
    name: "StarAgency",
    component: () => import("@/view/activePage/starAgency/index"),
    meta: {
      // title: '上麦时长统计'
      title: "starAgency",
    },
  },
  {
    path: "/starAgencyRule",
    name: "starAgencyRule",
    component: () => import("@/view/activePage/starAgency/rule"),
    meta: {
      // title: '上麦时长统计'
      title: "starAgency",
    },
  },
  {
    path: "/noTargetWarning",
    name: "NoTargetWarning",
    component: () => import("@/view/activePage/noTargetWarning/index"),
    meta: {
      // title: '上麦时长统计'
      title: "noTargetWarning",
    },
  },
  {
    path: "/wheelRule",
    name: "WheelRule",
    component: () => import("@/view/activePage/wheelRule/index"),
    meta: {
      title: "wheelRule",
    },
  },
  {
    path: "/starRoom",
    name: "StarRoom",
    component: () => import("@/view/activePage/starRoom/index"),
    meta: {
      title: "starRoom",
    },
  },
  {
    path: "/inviteActive",
    name: "InviteActive",
    component: () => import("@/view/activePage/inviteActive/index"),
    meta: {
      title: "inviteActive",
    },
  },
  {
    path: "/inviteActive2",
    name: "InviteActive2",
    component: () => import("@/view/activePage/inviteActive2/index"),
    meta: {
      title: "inviteActive2",
    },
  },
  {
    path: "/pkRank",
    name: "PkRank",
    component: () => import("@/view/activePage/pkRank/index"),
    meta: {
      title: "pkRank",
    },
  },
  {
    path: "/pkRankRule",
    name: "PkRankRule",
    component: () => import("@/view/activePage/pkRank/rule"),
    meta: {
      title: "pkRankrule",
    },
  },
  {
    path: "/voiceStar",
    name: "VoiceStar",
    component: () => import("@/view/activePage/voiceStar/index"),
    meta: {
      title: "voiceStar",
    },
  },
  {
    path: "/weeklyRechargerEvent",
    name: "WeeklyRechargerEvent",
    component: () => import("@/view/activePage/weeklyRechargerEvent/index"),
    meta: {
      title: "weeklyRechargerEvent",
    },
  },
  {
    path: "/weeklyRechargerEventRule",
    name: "WeeklyRechargerEventRule",
    component: () => import("@/view/activePage/weeklyRechargerEvent/rule"),
    meta: {
      title: "weeklyRechargerEventRule",
    },
  },
  {
    path: "/halloweenBanner",
    name: "HalloweenBanner",
    component: () => import("@/view/activePage/halloweenBanner/index"),
    meta: {
      title: "halloweenBanner",
    },
  },
  {
    path: "/cpBanner",
    name: "CpBanner",
    component: () => import("@/view/activePage/cpBanner/index"),
    meta: {
      title: "cpBanner",
    },
  },
  {
    path: "/firstAnniversary",
    name: "FFFirstAnniversary",
    component: () => import("@/view/activePage/firstAnniversary/index"),
    meta: {
      title: "firstAnniversary",
      keepAlive: true,
    },
  },
  {
    path: "/firstAnniversaryRule",
    name: "FFFirstAnniversaryRule",
    component: () => import("@/view/activePage/firstAnniversary/rule"),
    meta: {
      title: "firstAnniversary",
    },
  },
  {
    path: "/ethiopiaSeller",
    name: "EthiopiaSeller",
    component: () => import("@/view/activePage/ethiopiaSeller/index"),
    meta: {
      title: "ethiopiaSeller",
    },
  },
  {
    path: "/guild2",
    name: "Guild2",
    component: () => import("@/view/activePage/guildNotAgent/index"),
    meta: {
      title: "Guild2",
    },
  },
  {
    path: "/luckGiftAc",
    name: "LuckGiftAc",
    component: () => import("@/view/activePage/luckGiftAc/index"),
    meta: {
      title: "luckGiftAc",
    },
  },
  {
    path: "/waterSplashingFestival",
    name: "WaterSplashingFestival",
    component: () => import("@/view/activePage/waterSplashingFestival/index"),
    meta: {
      title: "waterSplashingFestival",
    },
  },
  {
    path: "/vipexplain",
    name: "GameVip",
    component: () => import("@/view/activePage/gameVip/index"),
    meta: {
      title: "Vipexplain",
    },
  },
  {
    path: "/anchor_center",
    name: "Hostcenter",
    component: () => import("@/view/center_host/index"),
    meta: {
      title: "hostcenter",
    },
  },
  {
    path: "/anchor_center/gift",
    name: "HostcenterGift",
    component: () => import("@/view/center_host/gift"),
    meta: {
      title: "giftIncome",
    },
  },
  {
    path: "/anchor_center/detail",
    name: "HostcenterDetail",
    component: () => import("@/view/center_host/detailPage"),
    meta: {
      title: "hostcenterDetail",
    },
  },
  {
    path: "/star_host",
    name: "Starhost",
    component: () => import("@/view/star_host/index"),
    meta: {
      title: "starhost",
    },
  },
  {
    path: "/star_host/rule",
    name: "StarhostRule",
    component: () => import("@/view/star_host/rule"),
    meta: {
      title: "StarhostRule",
    },
  },
  {
    path: "/bd_center",
    name: "Bdcenter",
    component: () => import("@/view/bd_center/index"),
    meta: {
      title: "agentcenter",
    },
  },
  {
    path: "/agent_manage",
    name: "Agentcenter",
    component: () => import("@/view/center_agent/index"),
    meta: {
      title: "agentcenter",
    },
  },
  {
    path: "/center_agent/commissionDetail",
    name: "CommissionDetail",
    component: () => import("@/view/center_agent/commissionDetail"),
    meta: {
      title: "commissionDetail",
    },
  },
  {
    path: "/center_agent/twoList",
    name: "TwoList",
    component: () => import("@/view/center_agent/twoList"),
    meta: {
      title: "twoList",
    },
  },
  {
    path: "/center_agent/otherIncome",
    name: "OtherIncome",
    component: () => import("@/view/center_agent/otherIncome"),
    meta: {
      title: "otherIncome",
    },
  },
  {
    path: "/center_agent/hostIncome",
    name: "hostIncome",
    component: () => import("@/view/center_agent/hostIncome"),
    meta: {
      title: "hostIncome",
    },
  },
  {
    path: "/center_agent/agencyIncome",
    name: "agencyIncome",
    component: () => import("@/view/center_agent/agencyIncome"),
    meta: {
      title: "agencyIncome",
    },
  },
  // {
  //   path: "/center_agent/pointDetail",
  //   name: "PointDetail",
  //   component: () => import("@/view/center_agent/pointDetail"),
  //   meta: {
  //     title: "pointDetail",
  //   },
  // },
  {
    path: "/center_agent/policy",
    name: "Policy",
    component: () => import("@/view/center_agent/policy"),
    meta: {
      title: "policy",
    },
  },
  {
    path: "/center_agent/bdPolicy",
    name: "CdPolicy",
    component: () => import("@/view/center_agent/bdPolicy"),
    meta: {
      title: "policy",
    },
  },
  {
    path: "/center_agent/seniorPolicy",
    name: "SeniorPolicy",
    component: () => import("@/view/center_agent/seniorPolicy"),
    meta: {
      title: "policy",
    },
  },
  {
    path: "/center_agent/becomeAgent",
    name: "BecomeAgent",
    component: () => import("@/view/center_agent/becomeAgent"),
    meta: {
      title: "become agent",
    },
  },
  {
    path: "/merchant_coin",
    name: "CoinSeller",
    component: () => import("@/view/seller_coin/index"),
    meta: {
      title: "coin seller",
    },
  },
  {
    path: "/merchant_coin/payMethod",
    name: "PayMethod",
    component: () => import("@/view/seller_coin/payMethod"),
    meta: {
      title: "Payment Method",
    },
  },
  {
    path: "/merchant_coin/messege",
    name: "PayMessege",
    component: () => import("@/view/seller_coin/messege"),
    meta: {
      title: "Edit Message",
    },
  },
  {
    path: "/merchant_coin/payMethodType",
    name: "PayMethodType",
    component: () => import("@/view/seller_coin/payMethodType"),
    meta: {
      title: "",
    },
  },
  {
    path: "/merchant_coin/operate",
    name: "Operate",
    component: () => import("@/view/seller_coin/operate"),
    meta: {
      title: "operate",
    },
  },
  {
    path: "/merchant_coin/payment",
    name: "Payment",
    component: () => import("@/view/seller_coin/payment"),
    meta: {
      title: "payment",
    },
  },
  {
    path: "/merchant_coin/paymentBA",
    name: "PaymentBA",
    component: () => import("@/view/seller_coin/payment_BA"),
    meta: {
      title: "paymentBA",
    },
  },
  {
    path: "/merchant_coin/rule",
    name: "CoinSellerRule",
    component: () => import("@/view/seller_coin/rule"),
    meta: {
      title: "rule",
    },
  },
  {
    path: "/merchant_coin/order",
    name: "CoinSellerOrder",
    component: () => import("@/view/seller_coin/order"),
    meta: {
      title: "order",
    },
  },
  {
    path: "/merchant_coin/detail",
    name: "CoinSellerDetail",
    component: () => import("@/view/seller_coin/detail"),
    meta: {
      title: "detail",
    },
  },
  {
    path: "/merchant_coin/transferDetail",
    name: "TransferDetail",
    component: () => import("@/view/seller_coin/transferDetail"),
    meta: {
      title: "transferDetail",
    },
  },
  {
    path: "/merchant_coin/exchangeDetail",
    name: "ExchangeDetail",
    component: () => import("@/view/seller_coin/exchangeDetail"),
    meta: {
      title: "exchangeDetail",
    },
  },
  {
    path: "/merchant_coin/rechargeDetail",
    name: "RechargeDetail",
    component: () => import("@/view/seller_coin/rechargeDetail"),
    meta: {
      title: "rechargeDetail",
    },
  },
  {
    path: "/merchant_coin/detailList",
    name: "DetailList",
    component: () => import("@/view/seller_coin/detailList"),
    meta: {
      title: "detailList",
    },
  },
  {
    path: "/merchant_coin/refuse",
    name: "RefuseOrder",
    component: () => import("@/view/seller_coin/refuse"),
    meta: {
      title: "refuse",
    },
  },
  {
    path: "/merchant_coin/priceRule",
    name: "PriceRule",
    component: () => import("@/view/seller_coin/priceRule"),
    meta: {
      title: "Price Rule",
    },
  },
  {
    path: "/invite_gameUser",
    name: "InviteGame",
    component: () => import("@/view/invite/game_invite"),
    meta: {
      title: "inviteGame",
    },
  },
  {
    path: "/invite_gameUser/rule",
    name: "InviteGameRule",
    component: () => import("@/view/invite/game_inviteRule"),
    meta: {
      title: "inviteGameRule",
    },
  },
  {
    path: "/invite_gameUser/userList",
    name: "InviteGameUserList",
    component: () => import("@/view/invite/game_inviteUserList"),
    meta: {
      title: "inviteGameUserList",
    },
  },
  {
    path: "/invite_gameUser/rewordList",
    name: "InviteGameRewordList",
    component: () => import("@/view/invite/game_inviteRewordList"),
    meta: {
      title: "inviteGameRewordList",
    },
  },
  {
    path: "/invite_anchor",
    name: "InviteHost",
    component: () => import("@/view/invite/host_invite"),
    meta: {
      title: "inviteHost",
    },
  },
  {
    path: "/invite_anchor/rule",
    name: "InviteHostRule",
    component: () => import("@/view/invite/host_inviteRule"),
    meta: {
      title: "inviteHostRule",
    },
  },
  {
    path: "/invite_anchor/rewordList",
    name: "InviteHostRewordList",
    component: () => import("@/view/invite/host_inviteRewordList"),
    meta: {
      title: "inviteHostRewordList",
    },
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("@/view/test"),
    meta: {
      title: "test",
    },
  },
  {
    path: "/share_gamePage",
    name: "ShareGame",
    component: () => import("@/view/share/game_share"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/share_Ins",
    name: "ShareIns",
    component: () => import("@/view/share/share_Ins"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/share_hostPage",
    name: "ShareHost",
    component: () => import("@/view/share/host_share"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/share_agentPage",
    name: "ShareAgent",
    component: () => import("@/view/share/agent_share"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/share_agentPage2",
    name: "ShareAgent2",
    component: () => import("@/view/share/agent_share2"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/share_livePage",
    name: "ShareHost",
    component: () => import("@/view/share/live_share"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/share_moment",
    name: "ShareMoment",
    component: () => import("@/view/share/moment_share"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/download",
    name: "Download",
    component: () => import("@/view/share/qrCode_share"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/iosOrAn",
    name: "IosOrAn",
    component: () => import("@/view/share/iosOrAn"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/recharge_h5",
    name: "Purchase",
    component: () => import("@/view/purchase/index"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/purchaseAgent",
    name: "PurchaseAgentList",
    component: () => import("@/view/purchase/purchaseAgentList"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/missionRule",
    name: "MissionRule",
    component: () => import("@/view/missionRule/index"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/nepalRule",
    name: "NepalRule",
    component: () => import("@/view/nepalRule/index"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/crownSeatRule",
    name: "CrownSeatRule",
    component: () => import("@/view/crownSeatRule/index"),
    meta: {
      title: "Hala",
    },
  },
  {
    path: "/bombRule",
    name: "BombRule",
    component: () => import("@/view/bombRule/index"),
    meta: {
      title: "bombRule",
    },
  },
  {
    path: "/bombRule2",
    name: "BombRule2",
    component: () => import("@/view/bombRule/index2"),
    meta: {
      title: "bombRule",
    },
  },
  {
    path: "/roomGiftRule",
    name: "RoomGiftRule",
    component: () => import("@/view/roomGiftRule/index"),
    meta: {
      title: "roomGiftRule",
    },
  },
  {
    path: "/roomGiftRule2",
    name: "RoomGiftRule2",
    component: () => import("@/view/roomGiftRule/index2"),
    meta: {
      title: "roomGiftRule",
    },
  },
  {
    path: "/gameLegacyHall",
    name: "GameLegacyHall",
    component: () => import("@/view/gameLegacyHall/index"),
    meta: {
      title: "gameLegacyHall",
    },
  },
  {
    path: "/gameLegacyHall2",
    name: "GameLegacyHall2",
    component: () => import("@/view/gameLegacyHall/index2"),
    meta: {
      title: "gameLegacyHall2",
    },
  },
  {
    path: "/gameLegacyHallRankRule",
    name: "GameLegacyHallRankRule",
    component: () => import("@/view/gameLegacyHall/rankRule"),
    meta: {
      title: "GameLegacyHallRankRule",
    },
  },
  {
    path: "/gameLegacyHallRule",
    name: "GameLegacyHallRule",
    component: () => import("@/view/gameLegacyHall/rule"),
    meta: {
      title: "GameLegacyHallRule",
    },
  },
  {
    path: "/serverMaintenance",
    name: "ServerMaintenance",
    component: () => import("@/view/activePage/serverMaintenance"),
    meta: {
      title: "ServerMaintenance",
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
